import { ServiceItemInterface } from '@/lib/definitions/services'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/Button'
import Tooltip from '@/components/Tooltip'
import BookOpenIcon from '@icons/book-open'

interface ServiceTileProps {
  serviceItem: ServiceItemInterface
  onClick: (serviceItem: ServiceItemInterface) => void
}

const ServiceTile = ({ serviceItem, onClick }: ServiceTileProps) => {
  const navigate = useNavigate()

  return (
    <div
      data-cy={serviceItem.id}
      className="flex items-start p-6 rounded-lg bg-white shadow-xs hover:shadow-neutral-20 hover:shadow-xl cursor-pointer transition-shadow duration-200 outline outline-2 outline-transparent hover:outline-text-link group min-h-[140px] group"
      onClick={() => {
        onClick(serviceItem)
        if (serviceItem.cta) {
          navigate(serviceItem.cta)
        }
      }}
    >
      <div className="flex flex-row space-x-4">
        <div className="w-full">
          <div className="flex mb-2 items-center space-x-4">
            <div className="flex items-center justify-center text-brand-5 transition-all duration-300 group-hover:scale-125">
              {serviceItem.icon}
            </div>
            <h5 className="text-xl text-text-base flex-1">
              {serviceItem.title}
            </h5>
            {serviceItem.knowledgeBaseUrl && (
              <Tooltip label="Knowledge Base" inline>
                <Button
                  as="link"
                  style="flat"
                  href={serviceItem.knowledgeBaseUrl}
                  target="_blank"
                  className="whitespace-nowrap py-1 px-2 bg-neutral-10 hover:bg-neutral-20"
                  onClick={(e) => {
                    e.stopPropagation()
                  }}
                >
                  <BookOpenIcon className="size-4 text-brand-1" />
                </Button>
              </Tooltip>
            )}
          </div>
          <p className="text-neutral-50 text-14 leading-4">
            {serviceItem.description}
          </p>
        </div>
      </div>
    </div>
  )
}

export default ServiceTile
